import React from "react";
import { practiceFeatures } from "../../config/practice";
import { coverageTitle, pillAmount, visitCoverage } from "./coveragestatus";

// The dashboard card's amount-due pill (narrow card: className "nc-copay";
// wide card: none). Caption and colour follow the visit's coverage status
// (./coveragestatus.js); Unverified is a neutral pill of the same size.
const CoveragePill = ({ row, amount, onClick, className = "" }) => {
  const status = visitCoverage(row, { usesEligibility: Boolean(practiceFeatures().osaPayments) });
  const classes = ["copay-pill", className, status.verified ? "" : "is-unverified"].filter(Boolean).join(" ");
  return (
    <button
      type="button"
      className={classes}
      title={coverageTitle(status)}
      data-coverage={status.verified ? "verified" : "unverified"}
      onClick={onClick}
      style={{ background: status.color, color: status.textColor }}
    >
      <span className="copay-pill-cap">{status.label}</span>
      <span className="copay-pill-amt">{pillAmount(status, amount)}</span>
    </button>
  );
};

export default CoveragePill;
